import { debounce } from 'lodash';
import React, { useState, useEffect, useCallback } from 'react';
import CreditCardEprotect from "../forms/CreditCardEProtect";
import { mobilepayDuck } from "../../ducks/mobilepay";
var mobilepayOperations = mobilepayDuck.operations;
export var EProtectSection = function EProtectSection(props) {
  var index = props.index,
      activeCategoryIndex = props.activeCategoryIndex,
      _props$defaultActive = props.defaultActive,
      defaultActive = _props$defaultActive === void 0 ? false : _props$defaultActive,
      payload = props.payload,
      tipAmount = props.tipAmount,
      check = props.check,
      orderId = props.orderId,
      code1 = props.code1,
      id = props.id,
      _props$functionName = props.functionName,
      functionName = _props$functionName === void 0 ? function () {
    return console.log("functionName");
  } : _props$functionName,
      _props$handleContinue = props.handleContinue,
      handleContinue = _props$handleContinue === void 0 ? function () {
    return console.log("handleContinue");
  } : _props$handleContinue,
      _props$setActiveCateg = props.setActiveCategoryIndex,
      setActiveCategoryIndex = _props$setActiveCateg === void 0 ? function () {
    return console.log("setActiveCategoryIndex");
  } : _props$setActiveCateg,
      _props$editFunction = props.editFunction,
      editFunction = _props$editFunction === void 0 ? function () {
    return console.log("editFunction");
  } : _props$editFunction,
      _props$setPayOrderPay = props.setPayOrderPayload,
      setPayOrderPayload = _props$setPayOrderPay === void 0 ? function () {
    return console.log('setPayOrderPayload');
  } : _props$setPayOrderPay,
      _props$payForOrder = props.payForOrder,
      payForOrder = _props$payForOrder === void 0 ? function () {
    return console.log('payForOrder');
  } : _props$payForOrder,
      _props$showMobilePayW = props.showMobilePayWPError,
      showMobilePayWPError = _props$showMobilePayW === void 0 ? function () {
    return console.log('sho/wMobilePayWPError');
  } : _props$showMobilePayW;
  return /*#__PURE__*/React.createElement(CreditCardEprotect, {
    check: check,
    handleContinue: handleContinue,
    setActiveCategoryIndex: setActiveCategoryIndex,
    activeCategoryIndex: activeCategoryIndex,
    functionName: functionName,
    editFunction: editFunction,
    orderId: orderId,
    code1: code1,
    tipAmount: tipAmount,
    payload: payload,
    id: id,
    setPayOrderPayload: setPayOrderPayload,
    payForOrder: payForOrder,
    showMobilePayWPError: showMobilePayWPError,
    fields: []
  });
};